module.exports = __webpack_public_path__ + "img/jhy.png";